import { useContext, useEffect, useState } from "react";
import { Context } from "../../../context/context";
import { Button, TextField } from "@mui/material";

import "./SellingZone.scss";
import { createZone } from "../../../services/zone-service";
import { redirect } from "react-router-dom";
import ZonesTable from "../../../components/Tables/ZonesTable/ZonesTable";

export default function SellingZone() {
  const [zone, setZone] = useState("");
  const token = localStorage.getItem("token");
  const { sidebar } = useContext(Context);

  const registerZone = async (e) => {
    e.preventDefault();

    try {
      const result = await createZone(token, { name: zone.toUpperCase() });

      if (result.data === "Unauthorized") {
        alert("Token inválido, faça login novamente.");
        redirect("/");
      }

      alert(
        `Zona ${zone.toUpperCase()} - ID ${result.data} cadastrada com sucesso.`
      );
    } catch (error) {
      alert("Algo deu errado. Tente novamente mais tarde.");
    }
  };

  return (
    <>
      <main className={sidebar ? "container" : "container-full"}>
        <h1>Cadastrar Zona de Venda</h1>
        <form className="zone-container">
          <TextField
            onChange={(e) => setZone(e.target.value)}
            label="Nome da Zona"
          />
          {zone && (
            <Button onClick={registerZone} variant="contained">
              Cadastrar
            </Button>
          )}
          <p>
            Antes de criar uma nova zona, verifique se ela já existe na tabela
            abaixo.
          </p>
        </form>
        <div className="table-container">
          <ZonesTable />
        </div>
      </main>
    </>
  );
}
